// «Куда ведёт» на сайте: цель приезжает с сервера уже с готовым адресом (backend/app/services/
// link_targets.py) — сайт адреса не собирает и видимость разделов не проверяет, только переходит.
// Вынесено из компонента: react-refresh требует, чтобы файл компонента экспортировал только компоненты.
import type React from 'react'

export interface PublicTarget {
	kind: string
	href: string | null
	external: boolean
	/** Только у цели-модели: 'провайдер:модель'. По нему витрина рисует логотип бренда (data/brands.ts). */
	ref?: string
	/** Ссылка открывается только сотруднику (раздел закрыт клиентам) — клиенту элемент вообще не приезжает. */
	staff_only?: boolean
	/** Только в стафф-превью: цель закрыта ('hidden') или сломана ('missing' | 'invalid'). */
	state?: 'hidden' | 'missing' | 'invalid'
	note?: string | null
}

/** Обычный клик левой кнопкой без модификаторов — его перехватывает SPA; всё остальное
 *  (⌘/ctrl/shift/alt, средняя кнопка) остаётся браузеру: новая вкладка, копирование адреса. */
export function isPlainLeftClick(e: Pick<React.MouseEvent, 'metaKey' | 'ctrlKey' | 'shiftKey' | 'altKey' | 'button'>): boolean {
	return !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0)
}

/** Рабочая ли ссылка: есть адрес и цель не помечена закрытой/сломанной. */
export function targetIsLive(target: PublicTarget | null | undefined): target is PublicTarget & { href: string } {
	return !!target && !!target.href && !target.state
}

/** Внутренний адрес тарифов: сайт открывает их окном поверх страницы, а не переходом. */
export function tariffsSearch(href: string): string | null {
	if (href !== '/tariffs' && !href.startsWith('/tariffs?')) return null
	return href.slice('/tariffs'.length)
}
